<mat-form-field>
  <input [(ngModel)]="profile.email" matInput placeholder="{{'userAdmin.profile.email' | translate}}" type="email"/>
</mat-form-field>
<div class="error-message" *ngIf="emailInvalid || emailAlreadyExists">
  {{'userAdmin.errors.' + (emailInvalid ? 'emailInvalid' : 'emailAlreadyExists') | translate}}
</div>

<smart-input [(model)]="profile" key="firstName" translationPrefix="userAdmin.profile"></smart-input>
<div class="error-message" *ngIf="firstNameInvalid">{{'userAdmin.errors.firstNameInvalid' | translate}}</div>
<smart-input [(model)]="profile" key="lastName" translationPrefix="userAdmin.profile"></smart-input>
<div class="error-message" *ngIf="lastNameInvalid">{{'userAdmin.errors.lastNameInvalid' | translate}}</div>

<div class="buttons">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.add' | translate }}</button>
</div>
